import type { FC } from "react";
import { WhatIfEarlierViz } from "web_myplann/Goals/Components/WhatIf/WhatIfEarlierViz";
import { WhatIfMoreViz } from "web_myplann/Goals/Components/WhatIf/WhatIfMoreViz";
import type { WhatIf, WhatIfCard } from "web_myplann/Goals/Hooks/useWhatIf";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	card: WhatIfCard;
	plan: WhatIf;
	currencyCode?: CurrencyEnum;
};

export const WhatIfCardViz: FC<Props> = ({ card, plan, currencyCode }) =>
	card === "earlier" ? (
		<WhatIfEarlierViz plan={plan} />
	) : (
		<WhatIfMoreViz plan={plan} currencyCode={currencyCode} />
	);
